import React, { FC } from 'react'

import { styled } from '@linaria/react'
import loadable from '@loadable/component'
import { FormattedMessage } from 'react-intl'

import { PrimaryButton } from 'components/designSystem/Button/PrimaryButton'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { Typography } from 'components/designSystem/Typography/Typography'
import { blogPath } from 'components/presentational/Navigation/Navigation.constants'

import icon from './dateBookIcon.svg'
import dateBook from './dateBookLogo.svg'
import thumbnails from './thumbnails.png'
import thumbnails_x2 from './thumbnails_x2.png'
import { ShowAfterIntersection } from '../ShowAfterIntersection'

export const DateBook: FC = () => {
  return (
    <Container>
      <DateBookHeader>
        <ShowAfterIntersection
          thumbnail={
            <img
              src={dateBook}
              loading="lazy"
              alt="Datebook"
              style={{ maxWidth: '100%' }}
            />
          }
        >
          <DateBookLogoLoadable />
        </ShowAfterIntersection>
      </DateBookHeader>
      <TextUnderLotte>
        <Typography fontSize={20} fontWeight={400}>
          <FormattedMessage
            id="date_book.text_2"
            defaultMessage="Как оформить анкету, искать подходящих людей, вести переписку и переводить мэтчи в реальные свидания."
          />
        </Typography>
      </TextUnderLotte>
      <Thumbnails
        srcSet={`${thumbnails} 1x, ${thumbnails_x2} 2x`}
        src={thumbnails}
        loading="lazy"
      />
      <PrimaryButton
        size="M"
        href={blogPath}
        icon={<img src={icon} width={31} height={31} loading="lazy" />}
        data-name="read-action"
      >
        <FormattedMessage id="app.read" defaultMessage="Читать" />
      </PrimaryButton>
    </Container>
  )
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 85px;
  margin-bottom: 20px;
`

const Text = styled.div`
  text-align: center;
  max-width: 500px;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    max-width: 90%;
  }
`

const DateBookHeader = styled.div`
  max-width: 522px;
  max-height: 156px;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    max-width: 90%;
  }
`

const Thumbnails = styled.img`
  margin-top: 28px;
  margin-bottom: 38px;
  width: 60%;
  height: auto;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    width: 90%;
  }
`

const TextUnderLotte = styled(Text)`
  position: relative;

  @media (min-width: ${breakpoints.mobile - 1}px) {
    margin-top: 40px;
  }
`

const DateBookLogoLoadable = loadable(() => import('./DateBookLogo'))
